import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'a[href="#"]'
})
export class ADirective {
  @HostListener('click', ['$event'])
  onClick(e) {
    e.preventDefault();
  }
}